import { HttpRegularGet } from "./index";

export const GetTemporaryInvoiceUrl = (invoiceNo: string, callback?: (result: string) => void, failCallback?: Function) => {
  HttpRegularGet(
    `/invoice/url/${invoiceNo}`, 
    (result) => {
      if (callback) callback(result.Result);
    }, 
    failCallback);
};

export const GetTemporaryAgencyFeeWeeklyExportUrl = (agencyFeeWeeklyExportId: string, callback?: (result: string) => void, failCallback?: Function) => {
  HttpRegularGet(`/agency-fee-weekly-export/url/${agencyFeeWeeklyExportId}`, (result) => {
    if (callback) callback(result.Result);
  }, failCallback);
};

